<script>
  import { createEventDispatcher } from 'svelte';
  import Mixins from '../utils/mixins';
  import Utils from '../utils/utils';
  import restProps from '../utils/rest-props';

  const dispatch = createEventDispatcher();

  let className = undefined;
  export { className as class };

  export let checked = undefined;
  export let name = undefined;
  export let value = undefined;
  export let disabled = undefined;
  export let readonly = undefined;

  let inputEl;

  $: classes = Utils.classNames(
    className,
    'radio',
    {
      disabled,
    },
    Mixins.colorClasses($$props),
  );

  function onChange(event) {
    dispatch('change', [event]);
    if (typeof $$props.onChange === 'function') $$props.onChange(event);
  }
</script>

<label class={classes} {...restProps($$restProps)}>
  <input
    bind:this={inputEl}
    type="radio"
    name={name}
    value={typeof value === 'undefined' ? '' : value}
    disabled={disabled}
    readonly={readonly}
    checked={checked}
    on:change={onChange}
  />
  <i class="icon-radio" />
  <slot />
</label>
